import styled from 'styled-components';

import { colorWhite, colorAccent } from 'styles/variables';

export const Wrapper = styled.div`
  display: flex;
  background: ${colorWhite};
  padding: 0 16px 16px;

  ${({ isFocused }) => {
    if (isFocused) {
      return `
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 3000000003;
        padding: 16px 0 16px 16px;
      `;
    }

    return '';
  }}
`;

export const CancelButton = styled.button`
  position: relative;
  padding: 10px 8px;
  margin: 0 8px;
  color: ${colorAccent};
  font-size: 14px;
  line-height: 16px;

  &:after {
    content: '';
    position: absolute;
    top: -4px;
    bottom: -4px;
    left: 0;
    right: 0;
    z-index: 1;
  }
`;
